import React, { Component } from 'react';
import OrderTable from "../Components/OrderTable";
import IntlMessages from 'util/IntlMessages';
import {isUndefined} from 'lodash'
export default class Ordrar extends Component {
    render() {
        console.log("Ordrarffffffffff",this.props)
        return (
            <div className="text-center">
                 <div className="text-center ">
                <h2 style={{ paddingTop: '12px', margin: '0',fontSize:"1.5rem",color:isUndefined(this.props.FontColor)?'#fff':this.props.FontColor}}><b><IntlMessages id="DashBoard.Status.Orders"/></b></h2>
            </div>
                <div className="d-flex justify-content-center" style={{overflowY:'auto',height:(parseInt(this.props.h)-1) * 35}}>
                    <OrderTable heightValue={this.props.heightValue} intervaltype={this.props.intervaltype} FontColor={this.props.FontColor}/>
                </div>
                <div className="d-flex justify-content-end w-100" style={{position: 'absolute', bottom: 4, right: 16,color:isUndefined(this.props.FontColor)?'#fff':this.props.FontColor}}>
                    <p>{this.props.getIntervalTypeText(this.props.intervaltype)}</p>
                </div>
            </div>
        )
    }
}